
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SidePanel extends Vue {
  @Prop({ default: '4rem 2rem 6rem' }) readonly padding!: string;
}
